import _flattenDeep from 'lodash/flatMapDeep'
import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import menuItems from 'utils/sidebarMenuItems'
import MenuItem from './MenuItem'

const defaultActiveMenu = 'CustomerInfo'

const Sidebar = () => {
  const { pathname } = useLocation()
  const [activedMenu, setMenuActived] = useState<string>(defaultActiveMenu)

  const flattenDeepMenuItems = useMemo(() => {
    return _flattenDeep(menuItems.map(x => x.items))
  }, [])

  useEffect(() => {
    if (pathname === '/') {
      setMenuActived(defaultActiveMenu)
      return
    }

    let current = flattenDeepMenuItems.find(
      x => x?.path === pathname.replace('/', '')
    )

    if (!current) {
      current = flattenDeepMenuItems.find(x => {
        return x?.path !== '/' && pathname.includes(x?.path || '')
      })
    }

    setMenuActived(current?.key || defaultActiveMenu)
  }, [flattenDeepMenuItems, pathname])

  return (
    <nav className="navbar navbar-vertical navbar-expand-lg">
      <div className="collapse navbar-collapse" id="navbarVerticalCollapse">
        <div className="navbar-vertical-content">
          <ul className="navbar-nav flex-column" id="navbarVerticalNav">
            {menuItems.map(item => {
              return (
                <MenuItem
                  activedMenu={activedMenu}
                  key={item.header as string}
                  menuItem={item}
                />
              )
            })}
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default Sidebar
